import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';

export default function ArticleList() {
  const { t } = useTranslation();
  const latestArticles = articles.slice(0, 9);

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
            {t('home:articles.title')}
          </h2>
          <p className="text-sm text-foreground-500">
            {t('home:articles.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:translate-y-[-2px]"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`爆料网 - ${article.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={idx < 6 ? 'eager' : 'lazy'}
                />
                {article.isHot && (
                  <span className="absolute top-3 right-3 bg-primary-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap">
                    热门
                  </span>
                )}
              </div>
              <div className="p-5">
                <span className="inline-block text-xs text-primary-500 bg-primary-500/8 px-2 py-0.5 rounded mb-3 whitespace-nowrap">
                  {article.categoryName}
                </span>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.viewCount.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-message-2-line"></i>
                      {article.commentCount.toLocaleString()}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/category/meiri-baoliao"
            className="inline-flex items-center gap-2 whitespace-nowrap bg-accent-500 hover:bg-accent-600 text-background-50 px-8 py-3 rounded-full text-sm font-medium cursor-pointer transition-colors"
          >
            {t('home:articles.readMore')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}